var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.payInit)?_c('div',{staticClass:"payment_box"},[_c('div',{staticStyle:{"margin-top":"30px","font-weight":"500","font-size":"16px"}},[_vm._v("支付中")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }